import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },

  {
    path: '/preview/:id',
    name: 'ReportPreview',
    component: () => import(/* webpackChunkName: "preview" */ '../views/ReportPreview.vue')
  },
  {
    path: '/report',
    name: 'FullReport',
    component: () => import(/* webpackChunkName: "full-report" */ '../views/FullReport.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/report/:id',
    redirect: to => {
      if (to.params && to.params.id) {
        try {
          sessionStorage.setItem('full_report_id', to.params.id)
        } catch (e) {
          // ignore
        }
      }
      return { name: 'FullReport', params: { id: to.params ? to.params.id : undefined } }
    }
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import(/* webpackChunkName: "pricing" */ '../views/Pricing.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/my',
    name: 'My',
    component: () => import(/* webpackChunkName: "my" */ '../views/My.vue')
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    component: () => import(/* webpackChunkName: "enterprise" */ '../views/Enterprise.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/compliance',
    name: 'Compliance',
    component: () => import(/* webpackChunkName: "compliance" */ '../views/Compliance.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !getToken()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
